// eslint-disable-next-line no-magic-numbers
const rowsPerPageOptions = [25, 50];

export default rowsPerPageOptions;
